import React, { PureComponent } from "react";
import { NavLink, Link } from "react-router-dom";
import anime from "animejs";
import _ from "lodash";
import { Icon, Dropdown, Menu } from "antd";

import {
  Logo,
  LanguageSwitcher,
  SocialList,
  Button,
  Burger,
  Modal,
} from "../components";
import { withRedux } from "../hoc";
import { logoutAction } from "../actions/page/auth";

const menus = [
  { path: "/", name: "Home" },
  { path: "/about", name: "About Us" },
  { path: "/news", name: "News" },
  { path: "/event", name: "Events" },
  { path: "/show", name: "Our Show" },
  { path: "/promotion", name: "Promotions" },
  { path: "/contact", name: "Contact Us" },
];

const actionToProps = { logoutAction };

const mapStateToProps = (state) => {
  return {
    t: _.get(state, "t"),
    language: _.get(state, "language"),
    auth: _.get(state, "auth"),
  };
};

@withRedux(mapStateToProps, actionToProps)
export default class Header extends PureComponent {
  state = {
    isTop: true,
    showMenu: false,
  };
  componentDidMount() {
    this.checkIsTop();
    window.addEventListener("scroll", this.onScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  }
  setIsTop = (isTop) => {
    if (this.state.isTop !== isTop) this.setState({ isTop });
  };
  onScroll = (e) => {
    this.checkIsTop();
  };
  checkIsTop = () => {
    this.setIsTop(window.scrollY === 0);
  };
  handleClickBurger = () => {
    this.setState({ showMenu: true }, () => {
      setTimeout(() => {
        anime({
          targets: ".ant-modal.menu .content .menu-list li",
          opacity: [0, 1],
          translateY: [50, 0],
          scale: [0, 1],
          duration: (el, i, l) => {
            return 1500 + i * 200;
          },
          delay: (el, i, l) => {
            return i * 150;
          },
        });
      }, 1);
    });
  };
  handleCloseModalMenu = () => {
    this.setState({ showMenu: false });
  };
  handleClickMenu = () => {
    this.setState({ showMenu: false });
  };
  renderHeaderDesktop = () => {
    const { auth, t } = this.props;
    const isLogin = _.get(auth, "isLogin");
    const isLoginChecked = _.get(auth, "isLoginChecked");
    const username = _.get(auth, "data.username");
    const menu = (
      <Menu>
        <Menu.Item onClick={() => this.props.actions.logoutAction()}>
          <p>{t('Logout')}</p>
        </Menu.Item>
      </Menu>
    );

    return (
      <div className="d-none d-lg-block desktop-mode">
        <div className="bg" />
        <div className="content">
          <div className="container">
            <div className="block">
              <div className="left">
                <Logo />
              </div>
              <div className="right">
                <ul className="menu">
                  <li>
                    <a
                      href="http://www.misstiffanyuniverse.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Miss Tiffany’s Universe
                    </a>
                  </li>
                  <li>
                    <a
                      href="http://www.missinternationalqueen.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Miss International Queen
                    </a>
                  </li>
                  <li>
                    <div className="callus">
                      <a href="tel:(+66) 38-421-700">
                        <Icon type="phone" />{" "}
                        <span className="text">(+66) 38-421-700 to 5</span>
                      </a>
                    </div>
                  </li>
                  <li>
                    <SocialList />
                  </li>
                  <li>
                    <LanguageSwitcher />
                  </li>
                  <li>
                    {/* <a
                      href="http://tiffany.cloudapp.net/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button type="primary">{t("Purchase Tickets")}</Button>
                    </a> */}
                    <a href={`${window.location.origin}/booking`}>
                      <Button type="primary">{t("Purchase Tickets")}</Button>
                    </a>
                    {/* <Link to='/agent'>
                      <Button className="agent-login-button" ghost bordercolor="#ffbd00">{t('Agent Login')}</Button>
                    </Link> */}
                  </li>
                  {isLoginChecked && (
                    <li>
                      {isLogin ? (
                        <Dropdown overlay={menu}>
                          <p>
                            {username} <Icon type="down" />
                          </p>
                        </Dropdown>
                      ) : (
                        <Link to="/agent">
                          <Button
                            className="agent-login-button"
                            ghost
                            bordercolor="#ffbd00"
                          >
                            {t("Agent Login")}
                          </Button>
                        </Link>
                      )}
                    </li>
                  )}

                  <li>
                    <Burger onClick={this.handleClickBurger} />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  renderHeaderMobile = () => {
    const { t } = this.props;
    return (
      <div className="d-lg-none mobile-mode">
        <div className="bg" />
        <div className="content">
          <div className="container">
            <div className="block">
              <div className="left">
                {/* <a
                  href="http://tiffany.cloudapp.net/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button type="primary">{t("Purchase Tickets")}</Button>
                </a> */}
                <a href={`${window.location.origin}/booking`}>
                  <Button type="primary">{t("Purchase Tickets")}</Button>
                </a>
              </div>
              <div className="right">
                <Burger onClick={this.handleClickBurger} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  renderContentModalMobile = () => {
    const { t } = this.props;
    return (
      <div className="d-lg-none mobile-mode">
        <div className="mobile-content">
          <div className="content-block block-1">
            <div className="reservation">
              <h2>{t('Reservation')}</h2>
              <p>
                Please feel free to Contact Us on
                <a href="tel:(+66) 38-421700">(+66) 38-421-700 (-5),</a>
                <a href="tel:(+66) 38-429642">(+66) 38-429-642</a> or Contact Us
                by
                <a href="mailto:res@tiffany-show.co.th">
                  {" "}
                  res@tiffany-show.co.th
                </a>
                , You can click the button below for book you seat quickly.
              </p>
              {/* <a
                href="http://tiffany.cloudapp.net/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button type="primary">{t("Purchase Tickets")}</Button>
              </a> */}
              <a href={`${window.location.origin}/booking`}>
                <Button type="primary">{t("Purchase Tickets")}</Button>
              </a>
            </div>
            <div className="follow-us">
              <h2>Follow us on...</h2>
              <p>
                Let’s get social. Follow us on social media to keep up to date
                with news and video.
              </p>
              <div className="container-social-list">
                <SocialList />
              </div>
            </div>
          </div>
          <div className="content-block block-2">
            <div className="miss-link">
              <ul>
                <li>
                  <a
                    href="http://www.misstiffanyuniverse.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Miss Tiffany’s Universe
                  </a>
                  <i className="fa fa-sign-out" />
                </li>
                <li>
                  <a
                    href="http://www.missinternationalqueen.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Miss International Queen
                  </a>
                  <i className="fa fa-sign-out" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };
  render() {
    const { isTop, showMenu } = this.state;
    const { t } = this.props;

    return (
      <header className={!isTop ? "on-scroll" : ""}>
        {this.renderHeaderDesktop()}
        {this.renderHeaderMobile()}
        <Modal
          className="menu"
          type="full"
          visible={showMenu}
          onCancel={this.handleCloseModalMenu}
        >
          <div className="container-language">
            <LanguageSwitcher />
          </div>
          <ul className="menu-list">
            {_.map(menus, (menu, index) => {
              return (
                <li key={index}>
                  <NavLink to={menu.path} onClick={this.handleClickMenu}>
                    {t(menu.name)}
                  </NavLink>
                </li>
              );
            })}
          </ul>
          {this.renderContentModalMobile()}
        </Modal>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js